import { render } from "./RichTextEditorCmp.vue?vue&type=template&id=9c04c57e"
import script from "./RichTextEditorCmp.vue?vue&type=script&lang=js"
export * from "./RichTextEditorCmp.vue?vue&type=script&lang=js"

import "./RichTextEditorCmp.vue?vue&type=style&index=0&id=9c04c57e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__